import { createMiddlewareAction } from './createMiddlewareAction'
import {
  endpoints,
  endpointsContactHospitals,
  endpointsContacts,
} from '../api/endpoints'
import { hospitalsContactsTypes } from '../constantes/actionTypes'

export const hospitalsContactsActions = {
  getAllContactsHospitals: () =>
    createMiddlewareAction({
      successType: hospitalsContactsTypes.GET_ALL_HOSPITALS_CONTACTS_SUCCESS,
      failureType: hospitalsContactsTypes.GET_ALL_HOSPITALS_CONTACTS_FAILURE,
      method: 'GET',
      endpoint: endpointsContactHospitals.GET_ALL_HOSPITAL_CONTACTS,
    }),
  getAllContactsHospitalsByZoneNamePaged: (page, comunidad, search) =>
    createMiddlewareAction({
      successType:
        hospitalsContactsTypes.GET_ALL_CONTACTS_BY_ZONE_NAME_PAGED_SUCCESS,
      failureType:
        hospitalsContactsTypes.GET_ALL_CONTACTS_BY_ZONE_NAME_PAGED_FAILURE,
      method: 'GET',
      endpoint:
        endpointsContactHospitals.GET_ALL_HOSPITAL_CONTACTS_BY_ZONE_NAME_PAGED(
          page,
          comunidad,
          search,
        ),
    }),
  deleteContactHospitals: (idContact) =>
    createMiddlewareAction({
      //elimina el contacto y todos sus hospitales
      successType: hospitalsContactsTypes.DELETE_HOSPITALS_CONTACT_SUCCES, //contactsTypes.DELETE_CONTACT_SUCCES,
      failureType: hospitalsContactsTypes.DELETE_HOSPITALS_CONTACT_FAILURE, //contactsTypes.DELETE_CONTACT_FAILURE,
      method: 'DELETE',
      endpoint: endpointsContacts.DELETE_CONTACTS(idContact),
    }),
  deleteOneHospitalContact: (idContactHospital) =>
    createMiddlewareAction({
      successType: hospitalsContactsTypes.DELETE_ONE_HOSPITAL_CONTACT_SUCCESS,
      failureType: hospitalsContactsTypes.DELETE_ONE_HOSPITAL_CONTACT_FAILURE,
      method: 'DELETE',
      endpoint: endpoints.DELETE_HOSPITAL_CONTACTS(idContactHospital),
    }),
  newHospitalContact: (contact) =>
    createMiddlewareAction({
      successType: hospitalsContactsTypes.NEW_HOSPITALS_CONTACT_SUCCESS,
      failureType: hospitalsContactsTypes.NEW_HOSPITALS_CONTACT_FAILURE,
      method: 'POST',
      endpoint: endpoints.NEW_HOSPITAL_CONTACTS,
      body: contact,
    }),
  clearAllContactHospitals: () => ({
    type: hospitalsContactsTypes.CLEAR_ALL_HOSPITALS_CONTACTS,
  }),
  updateHospitalContactDetails: (contact) =>
    createMiddlewareAction({
      successType: hospitalsContactsTypes.UPDATE_HOSPITALS_CONTACT_SUCCESS,
      failureType: hospitalsContactsTypes.UPDATE_HOSPITALS_CONTACT_FAILURE,
      method: 'PUT',
      endpoint: endpoints.UPDATE_HOSPITAL_CONTACTS,
      body: contact,
    }),
  updateContactDetails: (contact) =>
    createMiddlewareAction({
      successType: hospitalsContactsTypes.UPDATE_HOSPITALS_CONTACT_SUCCESS,
      failureType: hospitalsContactsTypes.UPDATE_HOSPITALS_CONTACT_FAILURE,
      method: 'PUT',
      endpoint: endpointsContacts.UPDATE_CONTACTS,
      body: contact,
    }),

  createContactNote: (idContact, note) =>
    createMiddlewareAction({
      successType: hospitalsContactsTypes.CREATE_HOSPITALS_CONTACT_NOTE_SUCCESS,
      failureType: hospitalsContactsTypes.CREATE_HOSPITALS_CONTACT_NOTE_FAILURE,
      method: 'POST',
      endpoint:
        endpointsContactHospitals.CREATE_HOSPITAL_CONTACT_NOTE(idContact),
      body: note,
    }),

  getContactNotes: (idContact) =>
    createMiddlewareAction({
      successType: hospitalsContactsTypes.GET_HOSPITALS_CONTACT_NOTES_SUCCESS,
      failureType: hospitalsContactsTypes.GET_HOSPITALS_CONTACT_NOTES_FAILURE,
      method: 'GET',
      endpoint: endpointsContactHospitals.GET_HOSPITAL_CONTACT_NOTES(idContact),
    }),

  deleteContactNote: (idContact, idNote) =>
    createMiddlewareAction({
      successType: hospitalsContactsTypes.DELETE_HOSPITALS_CONTACT_NOTE_SUCCESS,
      failureType: hospitalsContactsTypes.DELETE_HOSPITALS_CONTACT_NOTE_FAILURE,
      method: 'DELETE',
      endpoint: endpointsContactHospitals.DELETE_HOSPITAL_CONTACT_NOTE(
        idContact,
        idNote,
      ),
    }),
}
